'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function isFullScreenEnabled(element) {
  var video = element.querySelector('video') || {};
  return !!(document.fullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled || document.webkitSupportsFullscreen || video.webkitSupportsFullscreen || document.webkitFullscreenEnabled || video.webkitRequestFullScreen);
}

function isFullScreen(element) {
  var video = element.querySelector('video') || {};
  return !!(document.fullScreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement || document.fullscreenElement || video.webkitDisplayingFullscreen);
}
function requestFullscreen(element) {
  var video = element.querySelector('video') || {};
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullScreen) {
    element.webkitRequestFullScreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  } else if (video.webkitSupportsFullscreen) {
    video.webkitEnterFullscreen();
  }
}

function exitFullScreen(element) {
  var video = element.querySelector('video') || {};
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitCancelFullScreen) {
    document.webkitCancelFullScreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  } else if (video.webkitExitFullscreen) {
    video.webkitExitFullscreen();
  }
}

function onFullScreenChange(element, func) {
  var video = element.querySelector('video') || { addEventListener: function addEventListener() {} };
  video.addEventListener('webkitbeginfullscreen', func);
  video.addEventListener('webkitendfullscreen', func);
  element.addEventListener('fullscreenchange', func);
  element.addEventListener('webkitfullscreenchange', func);
  element.addEventListener('mozfullscreenchange', func);
}

exports.isFullScreenEnabled = isFullScreenEnabled;
exports.isFullScreen = isFullScreen;
exports.requestFullscreen = requestFullscreen;
exports.exitFullScreen = exitFullScreen;
exports.onFullScreenChange = onFullScreenChange;